@if (user.isAuthenticated) {
  <nav class="navbar navbar-expand bg-body-tertiary nav-menu-row">
    <div class="container-fluid nav-container">
      <!-- <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button> -->
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        @for (menuItem of navMenu; track menuItem) {
          @if (menuItem.menuId==='manageCsaUsers') {
            <li [ngClass]="user.isAuthenticated ? 'seprtr' : 'seprtr-disabled'"
            >|</li>
          }
          <li class="nav-item act" [class.dropdown]="user.isAuthenticated">
            @if (menuItem.menuId!=='ccm') {
              <a class="nav-link dropdown-toggle"
                [ngClass]="user.isAuthenticated && menuItem.isActive ? 'menu-header' : 'menu-header-disabled'"
                [routerLink]="menuItem.hasSubMenu ? null : menuItem.menuLink">
                {{menuItem.menuLabel | uppercase}}
              </a>
            }
            @if (menuItem.menuId==='ccm') {
              <a class="nav-link dropdown-toggle"
                [ngClass]="user.isAuthenticated && menuItem.isActive ? 'menu-header' : 'menu-header-disabled'"
                [routerLink]="[menuItem.hasSubMenu ? null : menuItem.menuLink,'mem']">
                {{menuItem.menuLabel | uppercase}}
              </a>
            }
            @if (menuItem.isActive && menuItem.hasSubMenu) {
              <ul class="dropdown-menu menu-list-color">
                <div class="seprtr-dropdown-menu">
                  <div
                    [ngClass]="{'wid-240': menuItem.menuId === 'employer', 'admtmenu': menuItem.adminToolsHeading === null, 'castmenu': menuItem.adminToolsHeading !== null }">
                    <span>{{content.labels.customer_assistance_tool}}</span>
                    @for (customerAssistanceTool of menuItem.customerAssistanceTools; track customerAssistanceTool) {
                      @if (customerAssistanceTool.hasAccess) {
                        <li
                          [ngClass]="{'pad-btm-16': customerAssistanceTool.subMenuId === 'healthcareSpendingReport'}">
                          @if (customerAssistanceTool.subMenuId !== 'ccm' &&
                            customerAssistanceTool.subMenuId !== 'brokerConnection' &&
                            customerAssistanceTool.subMenuId !== 'memberPaymentResearch' &&
                            customerAssistanceTool.subMenuId !== 'ifpEnrollments') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              [routerLink]="customerAssistanceTool.subMenuLink"
                              [queryParams]="customerAssistanceTool.ssoType ? {sso:customerAssistanceTool.ssoType }: null">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          <!-- Broker Connection: legacy flow – DSA role -->
                          @if (customerAssistanceTool.subMenuId === 'brokerConnection' &&
                            !isAzureLoginEnabled && customerAssistanceTool.accessIds[3] === 'PRIV_PRODUCER_DIRECT_SALES_AGENT') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              (click)="spoofBrokerConnection('dsa')">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          <!-- Broker Connection: Azure AD flow – Producer DSA group -->
                          @if (customerAssistanceTool.subMenuId === 'brokerConnection' &&
                            hasProducerDsaAccess() && customerAssistanceTool.accessIds[3] === 'PRIV_PRODUCER_DIRECT_SALES_AGENT') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              (click)="spoofBrokerConnection('dsa')">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          <!-- Broker Connection: legacy flow – Admin role -->
                          @if (customerAssistanceTool.subMenuId === 'brokerConnection' &&
                            !isAzureLoginEnabled && customerAssistanceTool.accessIds[3] === 'PRIV_PRODUCER_ADMIN') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              (click)="spoofBrokerConnection('admin')">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          <!-- Broker Connection: Azure AD flow – Producer REP or Super Admin group (DSA takes precedence) -->
                          @if (customerAssistanceTool.subMenuId === 'brokerConnection' &&
                            !hasProducerDsaAccess() && (hasProducerRepAccess() || hasSuperAdminAccess()) &&
                            customerAssistanceTool.accessIds[3] === 'PRIV_PRODUCER_ADMIN') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              (click)="spoofBrokerConnection('admin')">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          <!-- IFP Enrollments: legacy flow – Prospect search privilege -->
                          @if (ifpLinkEnabled && customerAssistanceTool.subMenuId === 'ifpEnrollments' &&
                            !isAzureLoginEnabled && customerAssistanceTool.accessIds[1] === 'PRIV_SEARCH_PROSPECT') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              (click)="spoofBrokerConnection('prospect_admin')">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          <!-- IFP Enrollments: Azure AD flow – Prospect REP or Super Admin group -->
                          @if (ifpLinkEnabled && customerAssistanceTool.subMenuId === 'ifpEnrollments' &&
                            (hasProspectRepAccess() || hasSuperAdminAccess())) {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              (click)="spoofBrokerConnection('prospect_admin')">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          @if (customerAssistanceTool.subMenuId === 'ccm') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? '_blank' : '_self'"
                              [routerLink]="[customerAssistanceTool.subMenuLink, 'mem']">{{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                          @if (customerAssistanceTool.subMenuId === 'memberPaymentResearch') {
                            <a class="dropdown-item menu-color"
                              [target]="customerAssistanceTool.openInNewTab ? 'MemberPaymentResearch' : '_self'"
                              [routerLink]="customerAssistanceTool.subMenuLink"
                              [queryParams]="customerAssistanceTool.ssoType ? {sso:customerAssistanceTool.ssoType }: null">
                              {{customerAssistanceTool.subMenuLabel}}
                            </a>
                          }
                        </li>
                      }
                    }
                  </div>
                  <div class="admtmenu">
                    <!-- <span>{{content.labels.admin_tools}}</span> -->
                    @if (menuItem.adminToolsHeading) {
                      <span>{{menuItem.adminToolsHeading}}</span>
                    }
                    @for (adminTool of menuItem.adminTools; track adminTool) {
                      @if (adminTool.hasAccess) {
                        <li>
                          <a class="dropdown-item menu-color"
                            [ngClass]="{'emp-adm': menuItem.menuId === 'employer' && adminTool.subMenuId === 'createExternalReportingAdmin'}"
                            [target]="adminTool.openInNewTab ? '_blank' : '_self'"
                            [routerLink]="adminTool.linkType !== 'method' ? adminTool.subMenuLink : null"
                            (click)="adminTool.linkType === 'method' ? onClick(adminTool.subMenuLink) : null"
                            [queryParams]="adminTool.ssoType ? {sso:adminTool.ssoType }: null">
                            {{adminTool.subMenuLabel}}
                          </a>
                        </li>
                      }
                    }
                  </div>
                </div>
              </ul>
            }
          </li>
        }
        <div class="feedback-img"><img src="assets/images/sm_996_oo.gif" alt="Feedback Icon"></div>
      </ul>
    </div>
  </div>
</nav>
}